export function guessMimeFromUrl(url: string): string | undefined {
  try {
    const u = new URL(url);
    const p = u.searchParams.get('mimeType');
    if (p) return p; // server put ?mimeType=image/png

    // fallback: extension sniff
    const ext = u.pathname.split('.').pop()?.toLowerCase();
    if (ext && /(jpe?g|png|gif|webp|svg)$/.test(ext))
      return `image/${ext === 'jpg' ? 'jpeg' : ext}`;
    if (ext && /(mp4|webm|ogg)$/.test(ext)) return `video/${ext}`;
  } catch {
    /* ignore */
  }
  return undefined;
}
